import _ from 'lodash'
import router from '@/router'
import Db from './loader.js';

const msisdnKeyname = 'msisdn';

async function requireConfigMsisdn () {
    let msisdn = await getMsisdn()
    if(!msisdn)
        router.replace({name: 'ManualMSISDN'})
}

async function storeMsisdn(msisdn) {
    try {
        await Db.configs.where('key').equalsIgnoreCase(msisdnKeyname).delete()
        let r = await Db.configs.add({
            key: msisdnKeyname,
            value: msisdn
        })
        let lectura = await getMsisdn()
        return (lectura == msisdn)
    } catch (e) {
        console.error(e)
    }
}

async function getMsisdn(){
    try {
        let msisdn = await Db.configs.where('key').equalsIgnoreCase(msisdnKeyname).first();
        if(_.isObjectLike(msisdn))
            return msisdn['value']
        else
            throw 'Lectura no exitosa'
    } catch(e){
        console.warn(e)
    }
}

async function clearMsisdn() {
    try {
        await Db.configs.where('key').equalsIgnoreCase(msisdnKeyname).delete()
        let lectura = await getMsisdn()
        return (lectura == undefined)
    } catch (e) {
        console.error(e)
    }
}

export {
    storeMsisdn, 
    clearMsisdn,
    requireConfigMsisdn,
    getMsisdn
}